import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { SearchYourProjectsFields } from '../../../features/feature-manage-projects/models/mp-search-your-projects-fields.interface'
import { SPOrderOptionKeyEnum } from '../../../features/feature-search-projects/models/sp-order-option.interface'
import { SearchProjectResult } from '../../../features/feature-search-projects/models/sp-result.interface'
import { BasicRequest } from '../../models/interfaces/basic-request.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { MPOrderOptionKeyEnum } from '../../../features/feature-manage-projects/models/mp-order-option.interface'

export const searchYourProjects = createAction('[manage-your-projects] Searching your projects', props<{ request: BasicRequest<SearchYourProjectsFields> }>())

export const searchYourProjectsSuccess = createAction(
   '[manage-your-projects] Searching your projects SUCCESS',
   props<{ result: BasicResult<SearchProjectResult[], BasicRequest<SearchYourProjectsFields>> }>()
)

export const searchYourProjectsFailure = createAction('[manage-your-projects] Searching your projects FAILURE', props<{ error: HttpErrorResponse }>())

export const setActualPageYourProjects = createAction('[manage-your-projects] Setting your projects actual page', props<{ page: number }>())

export const setActualOrderYourProjects = createAction('[manage-your-projects] Setting your projects actual order', props<{ order: string }>())

export const setSearchRequestYourProjects = createAction(
   '[manage-your-projects] Setting your projects search request',
   props<{ request: BasicRequest<SearchYourProjectsFields> }>()
)

export const initManageYourProjectSearch = createAction('[manage-your-projects] Init your projects search')

export const setItemForPageYourProjects = createAction('[manage-your-projects] Setting your projects item for page order', props<{ itemForPage: number }>())

export const exportExcelResults = createAction(
   '[manage-your-projects] Exporting excel results',
   props<{ searchFields?: BasicRequest<SearchYourProjectsFields> }>()
)

export const exportExcelResultsSuccess = createAction('[manage-your-projects] Exporting excel results SUCCESS')

export const exportExcelResultsFailure = createAction('[manage-your-projects] Exporting excel results FAILURE', props<{ error: HttpErrorResponse }>())
